export const round = (value: number, decimal: number, fixed?: boolean) => {
  const result = Number(value.toFixed(decimal));
  return !fixed ? result : result.toLocaleString(undefined, {
    minimumFractionDigits: decimal,
    maximumFractionDigits: decimal
  })
}

export const ordinal = (n: number): string => {
  const suffix = (n % 100 >= 11 && n % 100 <= 13)
    ? "th"
    : { 1: "st", 2: "nd", 3: "rd" }[n % 10] || "th";
  return `${n}${suffix}`;
}

export const addPercent = (value: number | string): string => {
  return `${value}%`;
}

export const reduceNumber = (value: number): string => {
  switch (true) {
    case value >= 1_000_000_000_000:
      return (value / 1_000_000_000_000).toFixed(1) + 'Q';
    case value >= 1_000_000_000:
      return (value / 1_000_000_000).toFixed(1) + 'B';
    case value >= 1_000_000:
      return (value / 1_000_000).toFixed(1) + 'M';
    case value >= 1_000:
      return (value / 1_000).toFixed(1) + 'K';
    default:
      return value.toString();
  }
}

export const addSeconds = (value: number | string): string => {
  return `${value}s`;
}

export const addDollars = (value: number | string): string => {
  return `$${value}`;
}
